// ===== DEFAULTS ===== //

// ===== PHASED LAUNCHDARKLY FLAGS ===== //
export const ADVANCED_LINE_ITEM_PRICE_SOURCE_PHASE_DEFAULT = 0;
export const SUGGESTED_PRICE_ENHANCEMENT_PHASE_DEFAULT = 0;

// ===== BOOLEAN LAUNCHDARKLY FLAGS ===== //
export const BUYER_LINE_ITEMS_PAGINATION_DEFAULT = false;
export const CAN_IMPORT_POST_SUBMISSION_DEFAULT = false;
export const EVENT_LEVEL_COLUMN_RENAME_DEFAULT = false;
export const USE_SPLIT_BASELINE_AUDIT_LOGS_DEFAULT = false;
